/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/StrategyProcessPhaseContent'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./StrategyProcessPhaseContent'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.StrategyProcessPhaseReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.StrategyProcessPhaseContent);
  }
}(this, function(ApiClient, StrategyProcessPhaseContent) {
  'use strict';




  /**
   * The StrategyProcessPhaseReport model module.
   * @module model/StrategyProcessPhaseReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>StrategyProcessPhaseReport</code>.
   * @alias module:model/StrategyProcessPhaseReport
   * @class
   */
  var exports = function() {
    var _this = this;







  };

  /**
   * Constructs a <code>StrategyProcessPhaseReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/StrategyProcessPhaseReport} obj Optional instance to populate.
   * @return {module:model/StrategyProcessPhaseReport} The populated <code>StrategyProcessPhaseReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('PhaseContents')) {
        obj['PhaseContents'] = ApiClient.convertToType(data['PhaseContents'], [StrategyProcessPhaseContent]);
      }
      if (data.hasOwnProperty('SwimLaneTitle')) {
        obj['SwimLaneTitle'] = ApiClient.convertToType(data['SwimLaneTitle'], 'String');
      }
      if (data.hasOwnProperty('Title')) {
        obj['Title'] = ApiClient.convertToType(data['Title'], 'String');
      }
      if (data.hasOwnProperty('StartDate')) {
        obj['StartDate'] = ApiClient.convertToType(data['StartDate'], 'Date');
      }
      if (data.hasOwnProperty('EndDate')) {
        obj['EndDate'] = ApiClient.convertToType(data['EndDate'], 'Date');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Array.<module:model/StrategyProcessPhaseContent>} PhaseContents
   */
  exports.prototype['PhaseContents'] = undefined;
  /**
   * @member {String} SwimLaneTitle
   * @default ''
   */
  exports.prototype['SwimLaneTitle'] = '';
  /**
   * @member {String} Title
   * @default ''
   */
  exports.prototype['Title'] = '';
  /**
   * @member {Date} StartDate
   */
  exports.prototype['StartDate'] = undefined;
  /**
   * @member {Date} EndDate
   */
  exports.prototype['EndDate'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


